import script from "./modernStatusChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./modernStatusChip.vue?vue&type=script&setup=true&lang=ts"

import "./modernStatusChip.vue?vue&type=style&index=0&id=74b08a63&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b08a63"]])

export default __exports__